import { DEFAULT_INPUT_INDICATOR_LABELS } from "../indicator/labels.js";
import { IndicatorCloseController, getIndicatorCloseDelay } from "../indicator/lifecycle.js";
import { deriveVolumeStatus, isVolumeIndicatorAction, predictVolumeActionOutcome } from "./status.js";
import { createState } from "@videojs/store";
//#region src/core/ui/volume-indicator/core.ts
const BOUNDARY_CLEAR_DELAY = 300;
const INITIAL_STATE = {
	open: false,
	generation: 0,
	level: null,
	value: null,
	fill: null,
	min: false,
	max: false,
	transitionStarting: false,
	transitionEnding: false
};
/** @internal */
var VolumeIndicatorCore = class {
	state = createState({ ...INITIAL_STATE });
	#props = {};
	#boundaryTimer = null;
	#close = new IndicatorCloseController(() => this.state.patch({
		open: false,
		level: null,
		value: null,
		fill: null,
		min: false,
		max: false
	}), () => getIndicatorCloseDelay(this.#props));
	setProps(props) {
		this.#props = props;
	}
	destroy() {
		this.#close.destroy();
		this.#clearBoundaryTimers();
	}
	close() {
		this.#clearBoundaryTimers();
		this.#close.close();
	}
	processEvent(event, snapshot) {
		if (!isVolumeIndicatorAction(event.action)) return false;
		const current = this.state.current;
		const prediction = predictVolumeActionOutcome(event, snapshot);
		const details = deriveVolumeStatus(event, snapshot, {
			...DEFAULT_INPUT_INDICATOR_LABELS,
			...this.#props.labels
		}, prediction);
		const boundary = getVolumeBoundary(event, prediction.snapshotVolume, prediction.nextVolume);
		const showBoundary = boundary !== null && !event.repeat;
		if (!boundary) this.#clearBoundaryTimers();
		this.state.patch({
			open: true,
			generation: current.generation + 1,
			level: details.volumeLevel,
			value: details.value,
			fill: details.value,
			min: boundary && event.repeat ? current.min : showBoundary && boundary === "min",
			max: boundary && event.repeat ? current.max : showBoundary && boundary === "max"
		});
		if (showBoundary) this.#scheduleBoundaryClear();
		this.#close.arm();
		return true;
	}
	#scheduleBoundaryClear() {
		this.#clearBoundaryTimer();
		this.#boundaryTimer = setTimeout(() => {
			this.#boundaryTimer = null;
			this.state.patch({
				min: false,
				max: false
			});
		}, BOUNDARY_CLEAR_DELAY);
	}
	#clearBoundaryTimer() {
		if (this.#boundaryTimer === null) return;
		clearTimeout(this.#boundaryTimer);
		this.#boundaryTimer = null;
	}
	#clearBoundaryTimers() {
		this.#clearBoundaryTimer();
	}
};
function getVolumeBoundary(event, currentVolume, nextVolume) {
	if (event.action !== "volumeStep" || event.value === void 0 || event.value === 0) return null;
	if (nextVolume !== currentVolume) return null;
	return event.value < 0 ? "min" : "max";
}
//#endregion
export { VolumeIndicatorCore };

//# sourceMappingURL=core.js.map